import styled from 'styled-components';

export const CurrentConditionIconDescription = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    font-weight: 400;
    height: 100%;
    width: 103px;
`;
